export default function rangeSlider() {
    const rangeSliders = document.querySelectorAll(".js-range-slider");

    rangeSliders.forEach(container => {
        const minInput = container.querySelector(".js-range-input-min");
        const maxInput = container.querySelector(".js-range-input-max");
        const track = container.querySelector(".js-range-track");
        const display = container.querySelector(".js-range-display");

        function updateSlider() {
            let minVal = parseInt(minInput.value);
            let maxVal = parseInt(maxInput.value);

            if (minVal > maxVal - 500000) {
                if (this === minInput) {
                    minInput.value = maxVal - 500000;
                    minVal = maxVal - 500000;
                } else {
                    maxInput.value = minVal + 500000;
                    maxVal = minVal + 500000;
                }
            }

            const minPercent = (minVal / minInput.max) * 100;
            const maxPercent = (maxVal / maxInput.max) * 100;

            track.style.left = minPercent + "%";
            track.style.right = (100 - maxPercent) + "%";

            const formatCurrency = (val) => {
                return new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                    maximumFractionDigits: 0,
                }).format(val);
            };

            display.textContent = `${formatCurrency(minVal)} - ${formatCurrency(maxVal)}`;
        }

        minInput.addEventListener("input", updateSlider);
        maxInput.addEventListener("input", updateSlider);
        
        // Inicializar
        updateSlider();
    });
}
